// src/router.js
import Vue from 'vue';
import Router from 'vue-router';
import Home from './pages/home/home-page.vue';
import Plan from './pages/plan/plan-page.vue';
import Login from './pages/login/login-page.vue';
import Account from './pages/account/account-page.vue';
import Help from './pages/help/help-page.vue';
import DefaultLayout from './layout/defaultLayout.vue';
import loginLayout from './layout/loginLayout.vue';
import ForgotPassword from './pages/forgot-password/forgotPassword.vue';
import Payment from './pages/payment/payment-page.vue';
import PaymentNotice from './pages/payment-notice/payment-notice.vue';
import Partner from './pages/partner/partner-page.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: DefaultLayout,
            children: [
                {
                    path: '',
                    name: 'Home',
                    component: Home
                }
            ]
        },
        {
            path: '/login',
            component: loginLayout,
            children: [
                {
                    path: '',
                    name: 'Login',
                    component: Login
                }
            ]
        },
        {
            path: '/forgot-password',
            component: loginLayout,
            children: [
                {
                    path: '',
                    name: 'ForgotPassword',
                    component: ForgotPassword
                }
            ]
        },
        {
            path: '/account',
            component: DefaultLayout,
            children: [
                {
                    path: '',
                    name: 'Account',
                    component: Account,
                    isAuthenticated: true
                }
            ]
        },
        {
            path: '/payment',
            component: DefaultLayout,
            children: [
                {
                    path: '',
                    name: 'Payment',
                    component: Payment,
                    isAuthenticated: true
                }
            ]
        },
        {
            path: '/partner',
            component: DefaultLayout,
            children: [
                {
                    path: '',
                    name: 'Partner',
                    component: Partner,
                    isAuthenticated: true
                }
            ]
        },
        {
            path: '/payment-notice',
            component: DefaultLayout,
            children: [
                {
                    path: '',
                    name: 'PaymentNotice',
                    component: PaymentNotice,
                    isAuthenticated: true
                }
            ]
        },
        {
            path: '/help',
            component: DefaultLayout,
            children: [
                {
                    path: '',
                    name: 'Help',
                    component: Help
                }
            ]
        },
        {
            path: '/plan',
            component: DefaultLayout,
            children: [
                {
                    path: '',
                    name: 'Plan',
                    component: Plan
                }
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    const isAuthenticated = localStorage.getItem('token');
    if (to.isAuthenticated) {
        if (isAuthenticated) {
            next();
        } else {
            next({ 
                path: '/login', 
                query: { redirect: to.fullPath }
            });
        }
    } else { 
        next();
    }
});

export default router;